import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
	Form,
	Row,
	Col,
	Card,
	Badge,
	notification,
	Tag,
	Spin,
	Space,
	Button,
	Divider,
} from "antd";
import { FormOutlined } from "@ant-design/icons";
import DefaultLayout from "../../components/layout/DefaultLayout";
import Header from "../../components/header";
// import equipmentRequestService from "../../services/equipmentRequest";
import approvalService from "../../services/approver";
import CommentSystem from "../../components/comment";
import CreatedByComponent from "../../components/commonDetails/createdBy";
import ApproversComponent from "../../components/commonDetails/approvers";
import InventoryShowComponent from "../../components/commonDetails/inventoryShow";
import CurrencyShowComponent from "../../components/commonDetails/currencyShow";
import ApproveDisapproveComponent from "../../components/commonDetails/approveDisapprove";
import TaskStatus from "../../components/commonDetails/taskStatus";
import FeedbackModal from "../../components/feedbackModal";
import { replaceLineBreaks } from "../../utils/helper";

import AddApproversComponent from "../../components/commonDetails/manageApprovers";
import { useSelector } from "react-redux";

import supportDeskService from "../../services/supportDesk";
import { getFileNameFromPath, downloadFile } from "../../utils/helper";

const SupportDeskDetails = () => {
	const [data, setData] = useState([]);
	const [loading, setLoading] = useState(false);
	const [form] = Form.useForm();
	const [status, setStatus] = useState(null);
	const { id } = useParams();
	const [assignedUserId, setAssignedUserId] = useState(null);
	const navigate = useNavigate();
	const [formId] = useState(8);
	const { currentUser } = useSelector((state) => state.user);

	// PRINT STYLES & PRINT HANDLER
  useEffect(() => {
    const style = document.createElement("style");
    style.innerHTML = `
      @media print {
        body * {
          visibility: hidden;
        }
        #qqq{
          display:none;
        }
        #ppp, #ppp * {
          visibility: visible;
        }
        #ppp {
          position: absolute;
          left: 0;
          top: 0;
        }
      }
    `;
    document.head.appendChild(style);
    return () => {
      document.head.removeChild(style);
    };
  }, []);
  // PRINT STYLES & PRINT HANDLER

  const [isPrintable, setIsPrintable] = useState(false);
  const handlePrintClick = () => {
    setIsPrintable(true);
    setTimeout(() => {
      window.print();
      setIsPrintable(false);
    }, 100);
  };

	// const getSupportDeskById = async () => {
	// 	setLoading(true);
	// 	await supportDeskService
	// 		.getSupportDeskById(id)
	// 		.then((response) => {
	// 			console.log("response all");
	// 			console.log(response);
	// 			setData(response.data);
	// 			setLoading(false);
	// 		})
	// 		.catch((error) => {
	// 			console.log("eerir fetch", error);
	// 			// navigate("/crf");
	// 		});
	// };
	const getSupportDeskById = async () => {
		setLoading(true);
		await supportDeskService
			.getSupportDeskById(id)
			.then((response) => {
				setData(response.data);
				setLoading(false);
			})
			.catch((error) => {
				console.error("Error fetching support desk data:", error);
				notification.error({
					message: "Error",
					description: error.response?.data?.message || "An error occurred",
				});
				navigate("/request-support-form");
			});
	};
	useEffect(() => {
		getSupportDeskById();
	}, []);

	const handleSubmit = async (values, isParallel) => {
		setLoading(true);
		const formattedValues = {
			status,
			approved_disapproved: false,
			form_id: formId,
			key: parseInt(id),
			reason: values.message,
			...(isParallel && { assigned_user_id: assignedUserId }),
		};

		const serviceMethod = isParallel
			? approvalService.updateParallelStatus
			: approvalService.updateStatus;

		try {
			const response = await serviceMethod(formattedValues);
			if (response.success) {
				notification.success({
					message: "Status",
					description: response.message,
				});
				form.resetFields();
				getSupportDeskById(id);
			}
		} catch (error) {
			notification.error({
				message: "Error",
				description: error.response?.data?.message || "An error occurred",
			});
		} finally {
			navigate("/dashboard");
			setLoading(false);
		}
	};

	// Comment Condition Updated
	let canComment = 0;
	if (data) {
		if (data.status != "Approved" && data.status != "Return") {
			canComment = 1;
		} else {
			if (data.comment_status == 1) {
				canComment = 1;
			}
		}
	}
	// Comment Condition Updated
	const Isadmin = currentUser.roles.includes("admin");

	//  For hiding next hierarchy to the user
	// let filteredApprovers = [];
	// if (data) {
	// 	const allApprovers = data.approvers;

	// 	if (Array.isArray(allApprovers)) {
	// 		filteredApprovers = allApprovers.map((approver) => ({
	// 			...approver,
	// 			users: approver.users
	// 				? approver.users.filter((user) => user.status === "Processing")
	// 				: [],
	// 		}));

	// 		console.log("filteredApprovers");
	// 		console.log(filteredApprovers);
	// 	} else {
	// 		console.error("allApprovers is not defined or is not an array.");
	// 	}
	// }

	console.log("asd");
	console.log(data);
	console.log("asd");
	//  For hiding next hierarchy to the user
	return (
		<DefaultLayout>
			<Row gutter={[24, 24]}>
				<Col span={24}>
					<Header icon={<FormOutlined />} title='Support Desk Details' />
				</Col>
			</Row>

			<Spin spinning={loading}>



				{/* PRINTABLE CARD */}
				{
				  isPrintable && (
				    <Card
				      style={{
				        minHeight: "100vh",
				        marginLeft: "-200px",
				        marginTop: "-50px",
				        border: "none",
				        padding: 24,
				        background: "#fff",
				      }}
				      id="ppp"
				    >
				      <Row gutter={[24, 24]}>
				        <Col span={24} style={{ textAlign: "center" }}>
				          <img
				            src={
				              currentUser?.company?.logo
				                ? currentUser.company.logo.replace("/uploads", "")
				                : "https://www.lucky-cement.com/wp-content/uploads/2017/02/lucky-logo.png"
				            }
				            alt="Logo"
				            style={{ height: "40px", width: "auto", marginBottom: 16 }}
				          />
				          <h2 style={{ marginBottom: 0 }}>
				            <strong>SCRF Request Details</strong>
				          </h2>
				          <div style={{ fontSize: 12, marginBottom: 16 }}>
				            <b>Sequence No:</b> {data.sequence_no} &nbsp; | &nbsp;
				            <b>Request Title:</b> {data.request_title} &nbsp; | &nbsp;
				            <b>Priority:</b> {data.priority}
				          </div>
				        </Col>
				      </Row>
				      <Row gutter={[16, 16]}>
				      	
				        <Col xs={24} sm={12} md={8} lg={6} xl={6}>
				          <b>Sap ID /Windows ID</b> <Tag>{data?.relevant_id}</Tag>
				        </Col>
				        <Col xs={24} sm={12} md={8} lg={6} xl={6}>
				          <b>Department:</b> <Tag>{data?.for_department?.name}</Tag>
				        </Col>
				        <Col xs={24} sm={12} md={8} lg={6} xl={6}>
				          <b>Service Required</b> <Tag>{data?.service?.name}</Tag>
				        </Col>
				        <Col xs={24} sm={12} md={8} lg={6} xl={6}>
				          <b>Team Required</b> 
							{data?.teams.map((team) => (
								<Tag key={team.id}>{team.name}</Tag> // Display each team name in a separate Tag
							))}
				        </Col>
				        <Col xs={24} sm={12} md={8} lg={6} xl={6}>
				          <b>Phone / Extension</b> <Tag>{data?.phone}</Tag>
				        </Col>
				      </Row>
				      <Divider/>
				      <Row gutter={[16, 16]}>
				        <Col xs={24} sm={12} md={8} lg={6} xl={6}>
				          <b>Location:</b> <Tag>{data?.for_location?.name}</Tag>
				        </Col>
				        <Col xs={24} sm={12} md={8} lg={6} xl={6}>
				          <b>Task Status:</b> <Tag>{data?.task_status?.name}</Tag>
				        </Col>
				      </Row>
				      <Divider/>
				      <Row gutter={[16, 16]}>
				        <Col span={24}>
				          <b>Description:</b>
				          <div
				            style={{ marginTop: 8 }}
				            dangerouslySetInnerHTML={{
				              __html: replaceLineBreaks(data.description),
				            }}
				          />
				        </Col>
				      </Row>
				      <Divider />
				      <Row gutter={[16, 16]}>
				        <Col span={24} style={{ fontSize: 12, marginTop: 16 }}>
				          This document has been approved through the system-based workflow.
				          <br />
				          Detailed information for SCRF ID: {id} can be accessed from this link.{" "}
				          <a
				            href={window.location.href}
				            target="_blank"
				            rel="noopener noreferrer"
				          >
				            View Details
				          </a>
				        </Col>
				      </Row>
				    </Card>
				  )}
				{/*Print End*/}


				<Card style={{ minHeight: "100vh" }} id='qqq'>
					<Row gutter={[24, 24]}>
						<Col lg={5} md={5} sm={7} xs={7}>
							<CreatedByComponent data={data} />
							<Button
                type='primary'
                onClick={handlePrintClick}
                style={{
                  marginTop: "20px",
                  marginBottom: "20px",
                  width: "100%",
                }}
              >
                Print Document
              </Button>
							{/* {data &&
								(data.status === "Pending" || data.status === "Approved") &&
								Isadmin === true && (
									<AddApproversComponent data={data && data} formId={formId} />
								)} */}
							{/*<ApproversComponent approvers={data && filteredApprovers} />*/}
							{/*<ApproversComponent approvers={data && data.approvers} />*/}
						</Col>

						<Col lg={19} md={19} sm={17} xs={17}>
							<div>
								{data?.approved_disapproved === true && (
									<div
										style={{
											position: "sticky",
											top: 1,
											zIndex: 999,
											background: "#fff",
											padding: "5px",
											borderRadius: "4px",
										}}
									>
										<Spin spinning={loading}>
											{data?.task_status?.id !== null && (
												<FeedbackModal
													title='QA Feedback'
													formId={formId}
													assurable_id={id}
													style={{ marginright: "0" }}
												/>
											)}
											<b>Approval Request</b>
											<ApproveDisapproveComponent
												form={form}
												handleStatus={(values) => handleSubmit(values, false)}
												loading={loading}
												setStatus={setStatus}
											/>
										</Spin>
									</div>
								)}

								{data?.parallel_approved_disapproved === true && (
									<div
										style={{
											position: "sticky",
											top: data?.approved_disapproved ? "150px" : "1px", // Adjust the top value as needed
											zIndex: 999,
											background: "#fff", // Add a background color
											padding: "5px", // Add padding for better visual separation
											borderRadius: "4px", // Optional: Add rounded corners
										}}
									>
										<Spin spinning={loading}>
											<b>Parallel Approval Request</b>
											<ApproveDisapproveComponent
												form={form}
												handleStatus={(values) => handleSubmit(values, true)}
												loading={loading}
												setStatus={setStatus}
												parallel={true}
												parallelUsers={
													data && data.parallel_approved_disapproved_users
												}
												setAssignedUserId={setAssignedUserId}
												reloadData={getSupportDeskById}
											/>
										</Spin>
									</div>
								)}

								<div className='mb-10'>
									{data?.assigned_task_to_me === true && (
										<div
											style={{
												position: "sticky",
												top: "1px",
												zIndex: 999,
												background: "#fff", // Add a background color
												padding: "5px", // Add padding for better visual separation
												borderRadius: "4px", // Optional: Add rounded corners
											}}
										>
											<TaskStatus
												data={data}
												reloadData={getSupportDeskById}
												formId={formId}
											/>
										</div>
									)}
								</div>

								{data && data.request_title && (
									<Card title='Basic Information' className='mb-10'>
										<Row gutter={[16, 16]}>
											<Col xs={24} sm={12} md={8} lg={6} xl={6}>
												<p className='fs-12 mb-10'>Sequence No</p>
												<Tag>{data.sequence_no}</Tag>
											</Col>

											<Col xs={24} sm={12} md={8} lg={6} xl={6}>
												<p className='fs-12 mb-10'>Query Title</p>
												<Tag>{data.request_title}</Tag>
											</Col>

											<Col xs={24} sm={12} md={8} lg={6} xl={6}>
												<p className='fs-12 mb-10'>Priority</p>
												<Tag>{data.priority}</Tag>
											</Col>

											<Col xs={24} sm={12} md={8} lg={6} xl={6}>
												<p className='fs-12 mb-10'>Sap ID /Windows ID</p>
												<Tag>{data.relevant_id}</Tag>
											</Col>
										</Row>

										<Row gutter={[16, 16]} className='mt-20'>
											<Col xs={24} sm={12} md={8} lg={6} xl={6}>
												<p className='fs-12 mb-10'>Department</p>
												<Tag>{data.for_department?.name}</Tag>
											</Col>

											<Col xs={24} sm={12} md={8} lg={6} xl={6}>
												<p className='fs-12 mb-10'>Service Required </p>
												<Tag>{data.service?.name}</Tag>
											</Col>

											<Col xs={24} sm={12} md={8} lg={6} xl={6}>
												<p className='fs-12 mb-10'>Team Required</p>
												{data.teams.map((team) => (
													<Tag key={team.id}>{team.name}</Tag> // Display each team name in a separate Tag
												))}
											</Col>

											<Col xs={24} sm={12} md={8} lg={6} xl={6}>
												<p className='fs-12 mb-10'>Phone / Extension</p>
												<Tag>{data.phone}</Tag>
											</Col>

											{data.for_location?.name && (
												<Col xs={24} sm={12} md={8} lg={6} xl={6}>
													<p className='fs-12 mb-10 bold'>Location</p>
													<Tag>{data.for_location.name}</Tag>
												</Col>
											)}
											{data.task_status?.name && (
												<Col xs={24} sm={12} md={8} lg={6} xl={6}>
													<p className='fs-12 mb-10 bold'>Task Status</p>
													<Tag>{data.task_status.name}</Tag>
												</Col>
											)}
										</Row>
										<Row gutter={[16, 16]} className='mt-20'>
											<Col xs={24} sm={12} md={24} lg={24} xl={24}>
												<p className='fs-12 mb-10'>Description</p>
												<Tag style={{ width: "100%" }}>{data?.description}</Tag>
											</Col>
										</Row>
									</Card>
								)}
								{Array.isArray(data?.attachments) &&
									data.attachments.length > 0 && (
										<Card title='Attachments' className='mb-10'>
											<table
												style={{ width: "100%", borderCollapse: "collapse" }}
											>
												<thead>
													<tr>
														<th
															style={{
																textAlign: "left",
																padding: 8,
																borderBottom: "1px solid #eee",
															}}
														>
															Title
														</th>
														<th
															style={{
																textAlign: "left",
																padding: 8,
																borderBottom: "1px solid #eee",
															}}
														>
															Preview
														</th>
														<th
															style={{
																textAlign: "left",
																padding: 8,
																borderBottom: "1px solid #eee",
															}}
														>
															Action
														</th>
													</tr>
												</thead>
												<tbody>
													{data.attachments.map((attachment) => {
														const isImage = (filename) =>
															/\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(filename);
														const fileUrl = attachment.filename;
														const fileTitle =
															getFileNameFromPath(attachment.original_title) ||
															getFileNameFromPath(attachment.filename);
														return (
															<tr key={attachment.id}>
																<td
																	style={{
																		padding: 8,
																		verticalAlign: "middle",
																	}}
																>
																	{fileTitle}
																</td>
																<td
																	style={{
																		padding: 8,
																		verticalAlign: "middle",
																	}}
																>
																	{isImage(fileUrl) ? (
																		<a
																			href={fileUrl}
																			target='_blank'
																			rel='noopener noreferrer'
																			title='Preview image'
																		>
																			<img
																				src={fileUrl}
																				alt={fileTitle}
																				style={{
																					width: 40,
																					height: 40,
																					objectFit: "cover",
																					borderRadius: 4,
																					border: "1px solid #eee",
																					boxShadow:
																						"0 1px 4px rgba(0,0,0,0.08)",
																				}}
																			/>
																		</a>
																	) : (
																		<span
																			style={{ color: "#aaa", fontSize: 12 }}
																		>
																			No preview
																		</span>
																	)}
																</td>
																<td
																	style={{
																		padding: 8,
																		verticalAlign: "middle",
																	}}
																>
																	<Button
																		size='small'
																		className='mb-10'
																		type='primary'
																		onClick={() => downloadFile(fileUrl)}
																	>
																		Download
																	</Button>
																</td>
															</tr>
														);
													})}
												</tbody>
											</table>
										</Card>
									)}
							</div>

							<CommentSystem
								id={id}
								form_id={formId}
								status={data && data.status}
								comment_status={1}
							/>
						</Col>
					</Row>
				</Card>
			</Spin>
		</DefaultLayout>
	);
};

export default SupportDeskDetails;
